import { match } from 'ts-pattern'

import type { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { DurationOperatorEditor } from './DurationOperatorEditor'
import { NameOperatorEditor } from './NameOperatorEditor'

export const PhasePropertyEditor: ConditionPropertyEditorComponent = props =>
  match(props.operator)
    .with('NAME', () => <NameOperatorEditor {...props} />)
    .with('DURATION', () => <DurationOperatorEditor {...props} />)
    .otherwise(() => null)
